<template>
  <div class="painel-salas-table-wrapper">
    <table class="painel-salas-table">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
          <th v-if="hasAction">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="rows.length === 0">
          <td :colspan="colSpan" class="painel-salas-table__empty">Nenhuma sala encontrada</td>
        </tr>
        <template v-else>
          <tr
            v-for="row in rows"
            :key="row.id"
          >
            <td v-for="column in columns" :key="`${row.id}-${column.key}`">
              {{ row[column.key] }}
            </td>
            <td v-if="hasAction">
              <button
                type="button"
                class="painel-salas-table__action"
                :title="actionTitle"
                @click="$emit('action', row)"
              >
                <IconLogs v-if="actionType === 'log'" />
                <IconGraph v-else-if="actionType === 'graph'" />
                <slot name="action-icon" :row="row" />
              </button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import IconLogs from '@/assets/icons/IconLogs.vue';
import IconGraph from '@/assets/icons/IconGraph.vue';

export default {
  name: 'PainelSalasTable',

  components: {
    IconLogs,
    IconGraph
  },

  props: {
    rows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => [],
      validator: (columns) =>
        Array.isArray(columns) &&
        columns.every(
          (column) =>
            column &&
            typeof column.key === 'string' &&
            typeof column.label === 'string'
        )
    },
    actionType: {
      type: String,
      default: null,
      validator: (value) => value === null || ['log', 'graph'].includes(value)
    }
  },

  computed: {
    hasAction() {
      return Boolean(this.actionType);
    },

    colSpan() {
      return Math.max(this.columns.length + (this.hasAction ? 1 : 0), 1);
    },

    actionTitle() {
      if (this.actionType === 'log') {
        return 'Ver logs';
      }

      if (this.actionType === 'graph') {
        return 'Ver gráfico';
      }

      return 'Ação';
    }
  }
};
</script>

<style scoped>
.painel-salas-table-wrapper {
  padding: 0 1.5rem;
  overflow-x: auto;
}

.painel-salas-table {
  width: 100%;
  margin: 1rem 0;
  border-collapse: collapse;
}

.painel-salas-table th {
  padding: 0.875rem 0.75rem;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  background: #005b61;
}

.painel-salas-table th:first-child {
  border-top-left-radius: 8px;
}

.painel-salas-table th:last-child {
  border-top-right-radius: 8px;
}

.painel-salas-table td {
  padding: 0.875rem 0.75rem;
  color: #374151;
  font-size: 0.875rem;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: middle;
}

.painel-salas-table tbody tr td {
  color: #374151;
  opacity: 1;
}

.painel-salas-table__empty {
  padding: 2rem;
  color: #6b7280;
  text-align: center;
}

.painel-salas-table__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.painel-salas-table__action:hover {
  opacity: 0.7;
}
</style>
